const baseUrl = process.env.API_ROOT || '';
const baseUrlMe = process.env.API_ROOTS || '';
const baseUrlsnssdk = process.env.API_ROOTSNSSDK || '';
export default {

  // 微信分享
  "getAccessToken": baseUrl + "wechat/getAccessToken", // 获取accessToken
  "getJsapiTicket": baseUrl + "wechat/getJsapiTicket", // 获取jsapi_ticket(暂时用不到)
  "getSignature": baseUrl + "wechat/getSignature", // 获取signature(暂时用不到)
  "handler": baseUrl + "wechat/handler", // 校验信息是否是从微信服务器发出，处理消息(暂时用不到)

  //行政区查询
  "queryIllnessList": baseUrlMe + "department/queryIllnessList",
  "queryAdminAreaList": baseUrlMe + "department/queryAdminAreaList",

  //公交查询
  "queryoOtagebusInfoList": baseUrlMe + "department/queryoOtagebusInfoList",

  //辟谣信息列表 + 详情
  "runmorRefuting": baseUrlMe + "runmorRefuting/list",
  "runmorRefutinginfo": baseUrlMe + "runmorRefuting/info",

  // 查詢病例小區
  "selectHomeList": baseUrlMe + "provinces/selectHomeList",
  // 搜索病例小區
  "selectIllness": baseUrlMe + "provinces/selectIllness",
  // 获取省市区
  "getprovinces": baseUrlMe + "provinces/list",
  // 全国省市病例小区
  "selectIllnessList": baseUrlMe + "provinces/selectIllnessList",

  //首页bannei
  "carouselList": baseUrlMe + "home/image/carouselList",

  //统计图
  "statisticsList" : baseUrlMe + "home/image/statisticsList",

  //统计图的接口-查询区域的数据
  "ncov_data" : baseUrlsnssdk +"ncov_data/",
  // 获取外部疫情数据
  // "snssdkInfo":baseUrlsnssdk+"home/v1/info/",
  "snssdkInfo":baseUrlMe+"sectnicSpot/info",
  
  //景区查询
  "regionList" : baseUrlMe + "sectnicSpot/regionList",
  "getProvinceTwo": baseUrlMe+"sectnicSpot/getProvince",
// 根据（省）id查询省下面的景区
  "getProvinceList": baseUrlMe+"sectnicSpot/getProvinceList",
}



// WEBPACK FOOTER //
// ./src/api/api.js